module.exports = __webpack_public_path__ + "static/media/3.d6e0a3c6.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audio/moan/3.mp3
// module id = 479
// module chunks = 0